import { routeHead } from "@/lib/routeHead";
import { META_DESCRIPTIONS } from "@/lib/metaDescriptions";
import { createFileRoute } from "@tanstack/react-router";
import MarketingSalesHub from "@/pages/MarketingSalesHub";

export const Route = createFileRoute("/marketing-sales")({
  head: () => routeHead('Marketing & Sales — AGAPE Products', META_DESCRIPTIONS.marketing.en, '/marketing-sales'),
  component: MarketingSalesHub,
});
